import { apiClient } from "../../config";
import { env } from "../../../config/env";

import {
  GetProductCategoriesResponse,
  GetProductCategoryResponse,
  SuccessResponse
} from "../../interface/productcategories.interface";

class AdminProductCategoriesService {

  /**
   * 📦 GET ALL
   */
  async getProductCategories(): Promise<GetProductCategoriesResponse> {
    const response = await apiClient.get<GetProductCategoriesResponse>(
      env.ADMIN_PRODUCT_CATEGORIES_URL
    );

    return response.data;
  }

  /**
   * 📄 GET ONE
   */
  async getProductCategory(id: string): Promise<GetProductCategoryResponse> {
    const response = await apiClient.get<GetProductCategoryResponse>(
      `${env.ADMIN_PRODUCT_CATEGORIES_URL}/${id}`
    );

    return response.data;
  }

  /**
   * ➕ CREATE
   */
  async createProductCategory(payload: FormData): Promise<SuccessResponse> {
    const response = await apiClient.post(
      env.ADMIN_PRODUCT_CATEGORIES_URL,
      payload
    );

    return response.data;
  }

  /**
   * ✏️ UPDATE
   */
  async updateProductCategory(
    id: string,
    payload: any
  ): Promise<SuccessResponse> {
    const response = await apiClient.put(
      `${env.ADMIN_PRODUCT_CATEGORIES_URL}/${id}`,
      payload
    );

    return response.data;
  }

  /**
   * 🖼️ UPDATE IMAGE
   */
  async uploadImageProductCategory(
    id: string,
    payload: FormData
  ): Promise<SuccessResponse> {
    const response = await apiClient.post(
      `${env.ADMIN_PRODUCT_CATEGORIES_URL}/${id}/image`, 
      payload
    );

    return response.data;
  }

  /**
   * 🗑️ DELETE
   */
  async deleteProductCategory(id: string): Promise<SuccessResponse> {
    const response = await apiClient.delete(
      `${env.ADMIN_PRODUCT_CATEGORIES_URL}/${id}`
    );

    return response.data;
  }
}

export const adminProductCategoriesService =
  new AdminProductCategoriesService();